import { PureComponent } from 'react';

import classNames from 'classnames';
import FormErrorMessage from 'components/FormErrorMessage';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import OverviewPropTypes from '../../../OverviewPropTypes';
import TableColor from '../../../widgets/TableColor';

export default class DisplayTypeField extends PureComponent {
  static propTypes = {
    absolute: PropTypes.bool,
    Chart: OverviewPropTypes.Chart,
    data: PropTypes.object.isRequired,
    displayType: PropTypes.string.isRequired,
    editWidget: PropTypes.bool.isRequired,
    group: OverviewPropTypes.selectedGroup,
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    msg: PropTypes.object.isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showHover: false,
    };
  }

  handleMouseEnter = () => {
    this.setState({ showHover: true });
  };

  handleMouseLeave = () => {
    this.setState({ showHover: false });
  };

  render() {
    const {
      absolute,
      Chart,
      data,
      displayType,
      editWidget,
      group,
      input,
      meta: { touched, error },
      msg,
      onSelect,
    } = this.props;
    const { showHover } = this.state;
    return (
      <div
        checked={input.checked}
        className={classNames(
          'col-lg-4',
          'dashboard-color-form__col',
          input.checked && 'dashboard-color-form__col--checked',
        )}
        onClick={onSelect}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        data-testid='select-widget-view-option'
      >
        {showHover ? (
          <div className='dashboard-layout-field__hover-block'>
            <div className='text-center'>
              <i className='fa fa-regular fa-circle-plus fa-3x' />
              <div className='text-base'>
                {get(msg, [
                  'dialog',
                  'groupSummary',
                  editWidget ? 'updateView' : 'addView',
                ])}
              </div>
            </div>
          </div>
        ) : null}
        <TableColor
          absolute={absolute}
          Chart={Chart}
          data={data}
          disableLink
          displayType={displayType}
          group={group}
          msg={msg}
        />
        {touched && error && (
          <FormErrorMessage>{msg.validation[error]}</FormErrorMessage>
        )}
      </div>
    );
  }
}
